import { Box } from "@mui/material";
import { StyledCustomTabs } from "../../../styled/CustomTabs";

export const TabPanel = ({ children, value, index }) => {
    return (
        <div role="tabpanel" hidden={value !== index} style={{ width: "100%" }}>
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

const TabsWithErrors = ({ tabIndex, tabs, errors, handleTabChange }) => {

    return (
        <StyledCustomTabs.TabsContainer
            orientation="vertical"
            value={tabIndex}
            onChange={handleTabChange}
        >
            {tabs.map((t) => {
                const TabComponent = errors?.[t.id] ? StyledCustomTabs.ErrorTabPanel : StyledCustomTabs.TabPanel;
                return (
                    <TabComponent key={t.id} label={t.label} />
                )
            })}
        </StyledCustomTabs.TabsContainer>
    )
}



export default TabsWithErrors;